import React, { useEffect, useState } from "react"; 

import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";

import { getCurrency } from "../../../../../MyApi/sb/currency";

import LoadingSpinner from "../../../../UI/spinner";
import SingleCurrency from "../singleCurrency";
import PagnationComponent from "../pagnationComponent";
import NoData from "../../../../UI/nodata";
import ErrorMessage from "../../../../UI/error";



const CurrencyDataTable = () => {
const [filterText ,setFilterText] = useState("")
const {t ,i18n} = useTranslation()
const lang = i18n.language
const { data, isLoading ,refetch ,error} = useQuery(["getCurrency" ,lang],()=>getCurrency(lang))





const currencies = data?.data || []
const responeMessage = data?.message

if(isLoading){
    return <LoadingSpinner/>
}
if(error){  
  return <ErrorMessage error={error}/>
}

if(currencies.length === 0){
  return<NoData responeMessage={responeMessage}/>
}


if(!data){
    return <div>no data available</div>
}


const filterdData = currencies.filter((currency)=>currency.name.toLowerCase().toString().includes(filterText) )
  return (
    <div className="container-fluid" > 
      <div className="card">
        <div className="table-responsive-sm">
        <table className="table-responsive-sm table table-striped table-hover">
            <thead >    
            <th scope="col">#</th> 
            <th scope="col">{t("Name")}</th>
            <th scope="col">{t("Currency")}</th>  
            <th scope="col">{t("Rate")}</th>
            <th scope="col">{t("Default")}</th>
            <th scope="col">{t("Actions")}</th>
            </thead>
          <tbody>
          {filterdData.map((currency)=> ( <SingleCurrency key={currency.id}  currency={currency}   refetch={refetch} lang={lang}/>))   }
          </tbody>
        </table> 
        </div>
        
      </div>
      <div className="d-flex justify-content-center">
           <PagnationComponent/>
        </div>   
    </div>
  );
};

export default CurrencyDataTable;
